import React from 'react';
export function BlinqCard() {
  return <div className="min-h-screen bg-gray-950 flex items-center justify-center p-8" data-id="element-361">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center overflow-hidden relative" style={{
      width: '1500px',
      height: '500px'
    }} data-id="element-362">
        {/* Wave SVG at bottom */}
        <svg className="absolute bottom-0 left-0 w-full" viewBox="0 0 1500 120" preserveAspectRatio="none" style={{
        height: '120px'
      }} data-id="element-363">
          <path d="M0,80 C300,20 600,100 900,60 C1100,30 1300,90 1500,50 L1500,120 L0,120 Z" fill="rgba(255,255,255,0.08)" data-id="element-364" />
          <path d="M0,90 C250,50 500,110 750,70 C1000,30 1250,100 1500,60 L1500,120 L0,120 Z" fill="rgba(255,255,255,0.05)" data-id="element-365" />
        </svg>

        <div className="flex items-center gap-6 relative z-10" data-id="element-366">
          {/* Logo Mark - white square with gradient text */}
          <div className="h-14 w-14 bg-white rounded-lg flex items-center justify-center shadow-lg shadow-black/10" data-id="element-367">
            <span className="text-xl font-bold tracking-tighter bg-gradient-to-br from-blue-600 to-purple-600 bg-clip-text" style={{
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-368">
              AI
            </span>
          </div>

          {/* Text Content */}
          <div className="flex flex-col justify-center pt-1" data-id="element-369">
            <h1 className="text-5xl font-bold text-white tracking-tight leading-none mb-2" data-id="element-370">
              Swedenmark AI
            </h1>
            <p className="text-lg text-white/70 font-medium tracking-wide" data-id="element-371">
              Cut costs. Grow revenue. Free your team.
            </p>
          </div>
        </div>
      </div>
    </div>;
}